import React from "react";

// Local
import { ButtonHover } from "../../styled/styled";
import TooltipOrgName from "./TooltipOrgName";

const Org = ({ orgCode, actions, state }) => {
  const { orgName, selected } = state.organization;

  return (
    <>
      <ButtonHover
        style={{ pointerEvents: "auto" }}
        className={
          orgCode === selected ? "active organization" : "organization"
        }
        onMouseEnter={() => actions.hoverOrganization(orgCode)}
        onMouseLeave={() => actions.unhoverOrganization()}
        onClick={() => actions.hoverOrganization(orgCode)}
      >
        {<small>{orgCode}</small>}
        {state.organization.orgCode === orgCode && (
          <TooltipOrgName orgName={orgName} />
        )}
      </ButtonHover>
    </>
  );
};

export default Org;
